import React from 'react';
import styles from './ContentCard.module.css';

export type ContentCardVariant = 'default' | 'danger';

interface ContentCardProps {
  children: React.ReactNode;
  className?: string;
  variant?: ContentCardVariant;
}

interface ContentCardGridProps {
  children: React.ReactNode;
  className?: string;
}

type ContentCardComponent = React.FC<ContentCardProps> & {
  Grid: React.FC<ContentCardGridProps>;
};

const ContentCardGrid: React.FC<ContentCardGridProps> = ({
  children,
  className = '',
}) => (
  <div className={[styles.grid, className].filter(Boolean).join(' ')}>
    {children}
  </div>
);

const ContentCard: ContentCardComponent = ({
  children,
  className = '',
  variant = 'default',
}) => (
  <div className={[styles.card, styles[`card-${variant}`], className].filter(Boolean).join(' ')}>
    {children}
  </div>
);

ContentCard.Grid = ContentCardGrid;

export default ContentCard;
